import * as React from 'react'
import type { RouteObject } from 'react-router'

const Capture = React.lazy(() => import('../views/Capture/Capture'))

export const PaymentRouter: RouteObject[] = [
    {
        element: <Capture />,
        path: '/capture',
    },
]
